var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcModal',{staticClass:"card-selector",on:{"close":_vm.close}},[_c('CreateNewCardCustomPicker',{attrs:{"title":_vm.title,"description":_vm.description,"show-created-notice":""},on:{"cancel":_vm.close,"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }